module.exports = __webpack_public_path__ + "img/13_demontage_dattier.b2d4ed65.gif";